import React from 'react';
import { 
  Box, 
  Typography, 
  Divider, 
  Avatar, 
  Paper,
  IconButton,
  Tooltip
} from '@mui/material';
import PetsIcon from '@mui/icons-material/Pets';
import InfoIcon from '@mui/icons-material/Info';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ListItemPetFood = ({ pet: reportData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const pet = reportData.pet;
  const product = reportData.product;
  const restPercentage = reportData.rest_percentage;

  const handleViewDetails = () => {
    navigate('/main/view-pet', { 
      state: { 
        id: pet.id
      } 
    });
  };

  return (
    <Paper elevation={0} sx={{ mb: 1 }}>
      <Box sx={{ display: 'flex', p: 1 }}>
        <Box sx={{ display: 'flex', flex: 1, cursor: 'pointer' }} onClick={handleViewDetails}>
          <Avatar 
            sx={{ width: 42, height: 42, mr: 1 }}
            alt={pet.name}
            src={pet.thumb_url}
          >
            {!pet.thumb_url && <PetsIcon />}
          </Avatar>
          
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
              {pet.name}
            </Typography>
            
            {pet.owners && pet.owners.length > 0 && (
              <Typography variant="caption" noWrap sx={{ display: 'block' }}>
                {t('layouts.fromOwner')} {pet.owners.map(owner => owner.name).join(', ')}
              </Typography>
            )}
            
            <Typography variant="caption" sx={{ display: 'block' }}>
              {t('reports.foodProduct')} {product.name}
            </Typography>

            <Typography variant="caption" sx={{ display: 'block', fontWeight: 'medium' }}>
              {t('reports.foodPercentage')} {restPercentage}%
            </Typography>
          </Box>
        </Box>
                
      </Box>
      
      <Divider sx={{ mx: 1 }} />
    </Paper>
  );
};

export default ListItemPetFood;
